import React, { useState, useEffect, useRef } from "react";
import { isBrowser, isMobile } from "react-device-detect";
import BarLoader from "react-bar-loader";

import "./tool.scss";
import "./index.styled.scss";

import close from "../../assets/img/icon/close.png";
import cross from "../../assets/img/cages/cross.svg";
import one from "../../assets/img/cages/one.svg";
import fench from "../../assets/img/cages/fench.svg";
import three from "../../assets/img/cages/three.svg";

import Net from "./net/net";
import Rebar from "./rebar/rebar";
import Pile from "./pile/pile";

import { fetchSteelTypes } from "Redux/middlwares/steelType";
import { useAppDispatch, useAppSelector } from "Redux/hooks";
import { useTranslation } from "react-i18next";
import Lottie from "react-lottie";
import animationData from "./save.json";

import { NET_SUBCLASS_TYPE } from "Constants/net-constants";
import { REBAR_SUBCLASS_TYPE } from "Constants/rebar-constants";
import { PILE_SUBCLASS_TYPE } from "Constants/pile-constants";
import {
  setCurrentOrderRebars,
  setCurrentOrderRebarCount,
} from "Redux/features/rebar";
import {
  setCurrentOrderNets,
  setCurrentOrderNetsCount,
} from "Redux/features/net";
import {
  setCurrentOrderPiles,
  setCurrentOrderPilesCount,
} from "Redux/features/pile";
import {
  setRowNumbers,
  removeOrderItem,
  setDuplicateRows,
} from "Redux/middlwares/order";
import { createRebar } from "Redux/middlwares/rebar";
import { createNet } from "Redux/middlwares/net";
import { createPile } from "Redux/middlwares/pile";

function Tool(props: any) {
  const {
    tab,
    setTab,
    edit,
    setEditTool,
    selectedTool,
    setSelectedTool,
    editOrderId,
    editMode,
    order,
    editToolId,
  } = props;
  const dispatch = useAppDispatch();
  const steelTypes = useAppSelector((state) => state.steelType.steelTypes);
  const currentOrderRebars = useAppSelector(
    (state) => state.rebar.currentOrderRebars
  );
  const currentOrderNets = useAppSelector(
    (state) => state.net.currentOrderNets
  );
  const currentOrderPiles = useAppSelector(
    (state) => state.pile.currentOrderPiles
  );

  const currentOrderRebarCount = useAppSelector(
    (state) => state.rebar.currentOrderRebarCount
  );
  const currentOrderNetsCount = useAppSelector(
    (state) => state.net.currentOrderNetsCount
  );
  const currentOrderPilesCount = useAppSelector(
    (state) => state.pile.currentOrderPilesCount
  );

  const rebarsRef = useRef(currentOrderRebars);
  const netsRef = useRef(currentOrderNets);
  const pilesRef = useRef(currentOrderPiles);
  const rebarCountRef = useRef(currentOrderRebarCount);
  const netCountRef = useRef(currentOrderNetsCount);
  const pileCountRef = useRef(currentOrderPilesCount);
  const duplicateQueueRef = useRef<Promise<unknown>>(Promise.resolve());

  useEffect(() => {
    rebarsRef.current = currentOrderRebars;
  }, [currentOrderRebars]);

  useEffect(() => {
    netsRef.current = currentOrderNets;
  }, [currentOrderNets]);

  useEffect(() => {
    pilesRef.current = currentOrderPiles;
  }, [currentOrderPiles]);

  useEffect(() => {
    rebarCountRef.current = currentOrderRebarCount;
  }, [currentOrderRebarCount]);

  useEffect(() => {
    netCountRef.current = currentOrderNetsCount;
  }, [currentOrderNetsCount]);

  useEffect(() => {
    pileCountRef.current = currentOrderPilesCount;
  }, [currentOrderPilesCount]);

  const [loader, setLoader] = useState(false);
  const [isStopped, setIsStopped] = useState(true);
  const { t } = useTranslation(["common", "tool"]);

  useEffect(() => {
    if (steelTypes.length === 0) {
      dispatch(fetchSteelTypes());
    }
  }, [dispatch, steelTypes.length]);

  const checkRowNums = async (
    oldIndex: number,
    newIndex: number,
    data: any,
    subClassType: string
  ) => {
    let currentData;
    if (oldIndex < newIndex) {
      currentData = data.slice(oldIndex, newIndex + 1);
    } else {
      currentData = data.slice(newIndex, oldIndex + 1);
    }

    const pos_IdObj = currentData.reduce((acc, val) => {
      const Index = data.indexOf(val);
      acc[val.id] = Index + 1;
      return acc;
    }, {});

    let rowNums = {};
    if (NET_SUBCLASS_TYPE === subClassType) {
      rowNums = {
        net: pos_IdObj,
      };
    } else if (REBAR_SUBCLASS_TYPE === subClassType) {
      rowNums = {
        rebar: pos_IdObj,
      };
    } else if (PILE_SUBCLASS_TYPE === subClassType) {
      rowNums = {
        pile: pos_IdObj,
      };
    }

    dispatch(setRowNumbers(rowNums)).then(() => {
      if (NET_SUBCLASS_TYPE === subClassType) {
        const updatedOrderNets = currentOrderNets.map((element) => {
          if (pos_IdObj[element.id] !== undefined) {
            return {
              ...element,
              row_number: pos_IdObj[element.id],
            };
          } else {
            return element;
          }
        });
        updatedOrderNets.sort((a, b) => a.row_number - b.row_number);
        dispatch(setCurrentOrderNets(updatedOrderNets));
      } else if (REBAR_SUBCLASS_TYPE === subClassType) {
        const updatedOrderRebars = currentOrderRebars.map((element) => {
          if (pos_IdObj[element.id] !== undefined) {
            return {
              ...element,
              row_number: pos_IdObj[element.id],
            };
          } else {
            return element;
          }
        });
        updatedOrderRebars.sort((a, b) => a.row_number - b.row_number);
        dispatch(setCurrentOrderRebars(updatedOrderRebars));
      } else if (PILE_SUBCLASS_TYPE === subClassType) {
        const updatedOrderPiles = currentOrderPiles.map((element) => {
          if (pos_IdObj[element.id] !== undefined) {
            return {
              ...element,
              row_number: pos_IdObj[element.id],
            };
          } else {
            return element;
          }
        });
        updatedOrderPiles.sort((a, b) => a.row_number - b.row_number);
        dispatch(setCurrentOrderPiles(updatedOrderPiles));
      }
    });
  };

  const deleteTool = (seletedOrderItem: any) => {
    if (seletedOrderItem.id) {
      dispatch(removeOrderItem(seletedOrderItem, editMode, editOrderId));
    }
  };

  const modifyRowNumbers = async (row: number, type: string) => {
    let sourceItems: any[] = [];
    let payloadKey = "";

    if (type === REBAR_SUBCLASS_TYPE) {
      sourceItems = rebarsRef.current;
      payloadKey = "rebar";
    } else if (type === NET_SUBCLASS_TYPE) {
      sourceItems = netsRef.current;
      payloadKey = "net";
    } else if (type === PILE_SUBCLASS_TYPE) {
      sourceItems = pilesRef.current;
      payloadKey = "pile";
    } else {
      throw new Error("Unsupported tool type");
    }

    const rowsToShift = sourceItems.filter(
      (item) => Number(item.row_number) > Number(row)
    );

    if (rowsToShift.length > 0) {
      const shiftedRows = rowsToShift.reduce((acc: any, item: any) => {
        acc[item.id] = Number(item.row_number) + 1;
        return acc;
      }, {});

      await dispatch(
        setDuplicateRows({
          [payloadKey]: shiftedRows,
        })
      );
    }

    const updatedItems = sourceItems
      .map((item) =>
        Number(item.row_number) > Number(row)
          ? {
              ...item,
              row_number: Number(item.row_number) + 1,
            }
          : item
      )
      .sort((a, b) => Number(a.row_number) - Number(b.row_number));

    if (type === REBAR_SUBCLASS_TYPE) {
      rebarsRef.current = updatedItems;
      await dispatch(setCurrentOrderRebars(updatedItems));
    } else if (type === NET_SUBCLASS_TYPE) {
      netsRef.current = updatedItems;
      await dispatch(setCurrentOrderNets(updatedItems));
    } else {
      pilesRef.current = updatedItems;
      await dispatch(setCurrentOrderPiles(updatedItems));
    }
  };

  const copyOrderItem = async (selectedTool: any) => {
    const performCopy = async () => {
      const toolItem = selectedTool as any;

      if (!toolItem || toolItem.id === 0) {
        return true;
      }

      const tool = { ...toolItem.tool };
      const orderItem = { ...toolItem };
      const callback = (_value: boolean) => {};

      ["id", "created", "last_modified", "default_image"].forEach(
        (key) => delete tool[key]
      );
      ["id", "tool", "created", "last_modified", "order"].forEach(
        (key) => delete orderItem[key]
      );

      const previewImageId = tool.preview_image?.id ?? tool.preview_image;
      if (!previewImageId) {
        throw new Error("לא התקבל מזהה לתמונה המקדימה");
      }
      tool.preview_image = previewImageId;

      const orderId = order?.order_id ?? editOrderId ?? 0;
      const duplicatedRow = Number(toolItem.row_number) + 1;

      if (toolItem.tool.subclass_type === REBAR_SUBCLASS_TYPE) {
        delete tool.icon;
        delete tool.rebar_filter;

        tool.rebar_side = Array.isArray(tool.rebar_side)
        ? tool.rebar_side.map((side: any) => {
            const copiedSide = { ...side };

            delete copiedSide.id;
            delete copiedSide.rebar;

            copiedSide.parent_line = null;
            copiedSide.symmetrical_side = null;

            if (copiedSide.end_point) {
              const copiedEndPoint = { ...copiedSide.end_point };
              delete copiedEndPoint.id;
              copiedSide.end_point = copiedEndPoint;
            }

            return copiedSide;
          })
        : [];

        await modifyRowNumbers(toolItem.row_number, REBAR_SUBCLASS_TYPE);
        await dispatch(
          createRebar(tool, orderItem, callback, duplicatedRow, orderId)
        );

        rebarCountRef.current += 1;
        await dispatch(setCurrentOrderRebarCount(rebarCountRef.current));
        return true;
      }

      if (toolItem.tool.subclass_type === NET_SUBCLASS_TYPE) {
        tool.x_diameter = tool.x_diameter?.id ?? tool.x_diameter;
        tool.y_diameter = tool.y_diameter?.id ?? tool.y_diameter;
        tool.tool_number = netsRef.current.length + 1;

        await modifyRowNumbers(toolItem.row_number, NET_SUBCLASS_TYPE);
        await dispatch(
          createNet(tool, orderItem, callback, duplicatedRow, orderId)
        );

        netCountRef.current += 1;
        await dispatch(setCurrentOrderNetsCount(netCountRef.current));
        return true;
      }

      if (toolItem.tool.subclass_type === PILE_SUBCLASS_TYPE) {
        tool.spiral_wire_diameter =
          tool.spiral_wire_diameter?.id ?? tool.spiral_wire_diameter;

        const deleteKeysPile: string[] = [];

        if (!tool.ring_diameter) {
          deleteKeysPile.push("ring_diameter", "ring_quantity");
        }
        if (!tool.gama_diameter) {
          deleteKeysPile.push("gama_diameter", "gama_quantity");
        }
        if (!tool.ear_type) {
          deleteKeysPile.push("ear_type", "ear_length");
        }

        const baseDiameterId = tool.base_diameter?.id ?? tool.base_diameter;
        const externalDiameterId =
          tool.external_diameter?.id ?? tool.external_diameter;
        const middleDiameterId =
          tool.middle_diameter?.id ?? tool.middle_diameter;
        const internalDiameterId =
          tool.internal_diameter?.id ?? tool.internal_diameter;

        if (baseDiameterId) {
          deleteKeysPile.push(
            "external_diameter",
            "external_amount",
            "middle_diameter",
            "middle_amount",
            "internal_diameter",
            "internal_amount"
          );
          tool.base_diameter = baseDiameterId;
        } else if (
          externalDiameterId &&
          middleDiameterId &&
          internalDiameterId
        ) {
          deleteKeysPile.push("base_diameter", "base_amount");
          tool.external_diameter = externalDiameterId;
          tool.middle_diameter = middleDiameterId;
          tool.internal_diameter = internalDiameterId;
        } else if (externalDiameterId && internalDiameterId) {
          deleteKeysPile.push(
            "base_diameter",
            "base_amount",
            "middle_diameter",
            "middle_amount"
          );
          tool.external_diameter = externalDiameterId;
          tool.internal_diameter = internalDiameterId;
        }

        deleteKeysPile.forEach((key) => delete tool[key]);

        await modifyRowNumbers(toolItem.row_number, PILE_SUBCLASS_TYPE);
        await dispatch(
          createPile(tool, orderItem, callback, duplicatedRow, orderId)
        );

        pileCountRef.current += 1;
        await dispatch(setCurrentOrderPilesCount(pileCountRef.current));
        return true;
      }

      throw new Error("סוג הפריט לשכפול אינו נתמך");
    };

    const queuedCopy = duplicateQueueRef.current.then(performCopy, performCopy);
    duplicateQueueRef.current = queuedCopy.then(
      () => undefined,
      () => undefined
    );

    return queuedCopy;
  };

  return (
    <>
      {isBrowser && (
        <section
          id="add__rebak"
          className={
            "tools " +
            (tab === 2 ? "net__tools" : "") +
            (tab === 3 ? "pile__tools" : "")
          }
        >
          <div className="tool-container">
            {tab === 1 && (
              <Rebar
                loader={loader}
                setLoader={setLoader}
                handleClose={props.onHide}
                edit={edit}
                setEditTool={setEditTool}
                selectedTool={selectedTool}
                setSelectedTool={setSelectedTool}
                setIsStopped={setIsStopped}
                tab={tab}
                setTab={setTab}
                checkRowNums={checkRowNums}
                editOrderId={editOrderId}
                editMode={editMode}
                deleteTool={deleteTool}
                copyOrderItem={copyOrderItem}
                order={order}
                editToolId={editToolId}
              />
            )}
            {tab === 2 && (
              <Net
                setLoader={setLoader}
                handleClose={props.onHide}
                edit={edit}
                setEditTool={setEditTool}
                selectedTool={selectedTool}
                setSelectedTool={setSelectedTool}
                setIsStopped={setIsStopped}
                tab={tab}
                setTab={setTab}
                checkRowNums={checkRowNums}
                editOrderId={editOrderId}
                editMode={editMode}
                deleteTool={deleteTool}
                copyOrderItem={copyOrderItem}
                order={order}
                editToolId={editToolId}
              />
            )}
            {tab === 3 && (
              <Pile
                setLoader={setLoader}
                handleClose={props.onHide}
                edit={edit}
                setEditTool={setEditTool}
                selectedTool={selectedTool}
                setSelectedTool={setSelectedTool}
                setIsStopped={setIsStopped}
                tab={tab}
                setTab={setTab}
                checkRowNums={checkRowNums}
                editOrderId={editOrderId}
                editMode={editMode}
                deleteTool={deleteTool}
                copyOrderItem={copyOrderItem}
                order={order}
                editToolId={editToolId}
              />
            )}
            <div
              className="animation-container"
              style={isStopped ? { display: "none" } : {}}
            >
              <Lottie
                options={{
                  loop: false,
                  autoplay: false,
                  animationData: animationData,
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={200}
                width={200}
                isStopped={isStopped}
                speed={2}
              />
            </div>
          </div>
        </section>
      )}
      {isMobile && (
        <div className="cage__wrapper add__rebar">
          <section className="top__section py-5">
            <div className="container d-flex flex-column">
              <div className="close">
                <div className="icon__wrap text-right justify-content-end">
                  <div
                    className="icon__wrap d-inline-block text-white"
                    onClick={props.onHide}
                  >
                    <img src={cross} alt="cross icon" />
                  </div>
                </div>
              </div>
              <div className="tittle py-3">
                <h3 className="text-uppercase text-center text-white mb-0">
                  choose your shape
                </h3>
              </div>
              {/* <!-- icons row  --> */}
              <div className="row m-0 bg-white py-4 border__bottom">
                <div className="col-4 text-center">
                  <span
                    onClick={() => setTab(1)}
                    className={
                      "icon__wrap one mx-auto" + (tab === 1 ? " active-bg" : "")
                    }
                  >
                    <img src={one} alt="icon" />
                  </span>
                  <p className="para text-center text-uppercase text-dark-500 mt-2">
                    rebar
                  </p>
                </div>
                <div className="col-4 text-center">
                  <span
                    onClick={() => setTab(2)}
                    className={
                      "icon__wrap two mx-auto" + (tab === 2 ? " active-bg" : "")
                    }
                  >
                    <img src={fench} alt="icon" />
                  </span>
                  <p className="para text-center text-uppercase text-dark-500 mt-2">
                    net
                  </p>
                </div>
                <div className="col-4 text-center">
                  <span
                    onClick={() => setTab(3)}
                    className={
                      "icon__wrap three mx-auto" +
                      (tab === 3 ? " active-bg" : "")
                    }
                  >
                    <img src={three} alt="icon" />
                  </span>
                  <p className="para text-center text-uppercase text-dark-500 mt-2">
                    Cage
                  </p>
                </div>
              </div>

              {tab === 1 && (
                <Rebar
                  setLoader={setLoader}
                  handleClose={props.onHide}
                  edit={edit}
                  selectedTool={selectedTool}
                />
              )}
              {tab === 2 && (
                <Net
                  setLoader={setLoader}
                  handleClose={props.onHide}
                  edit={edit}
                  selectedTool={selectedTool}
                />
              )}
              {tab === 3 && (
                <Pile
                  setLoader={setLoader}
                  handleClose={props.onHide}
                  edit={edit}
                  selectedTool={selectedTool}
                />
              )}
            </div>
          </section>
        </div>
      )}
    </>
  );
}

export default Tool;